




















import {MD5} from 'crypto-js'

import {defineComponent} from '@vue/composition-api'
import ImageWithBoundaryBox from '@/views/components/catalog/imageDetails/ImageWithBoundaryBox.vue'
import ProductDetails from '@/store/catalog/productDetails'

export default defineComponent({
  name: 'ProductDetailsImages',
  components: {ImageWithBoundaryBox},
  props: {
    productImages: {
      type: Array,
      default: () => [],
    },
    productId: {
      type: String,
      require: true,
    },
  },
  methods: {
    imageDetails(imageLink: string) {
      const imageId = MD5(imageLink).toString()
      if (ProductDetails.state.imagesDetails[imageId]) {
        return ProductDetails.state.imagesDetails[imageId]
      }
      return {}
    },
  },
})
